
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqCq1JuXKzdjEkS0KvSYtyW41KkHchJKhFCizcd2mGNdUMeta } from "/codebuild/output/src3390113751/src/src/pages/faq.vue?macro=true";
import { default as menuEL9xllHKdjjelJRabUhqdB9c8HVwG_45hTSmC_cLXKJFcMeta } from "/codebuild/output/src3390113751/src/src/pages/menu.vue?macro=true";
import { default as indexLdzqi7j7rODMRr4sbSA9u6AO__6_45RohVSE6WAGmgrPkMeta } from "/codebuild/output/src3390113751/src/src/pages/index.vue?macro=true";
import { default as contact8LfOkdTtNeqAhlRdenMvbbwtfbvPjbhJtdwOOMDbQwIMeta } from "/codebuild/output/src3390113751/src/src/pages/contact.vue?macro=true";
import { default as tutorialEwUuIhK9WMu8UiDjnlMNO_45LB_D0AkSXsg5YkkMmHdsoMeta } from "/codebuild/output/src3390113751/src/src/pages/tutorial.vue?macro=true";
import { default as agreement54AfTnXFYEWLcJNbxc9TfH5XmCKQmwzCD0PZngud5W0Meta } from "/codebuild/output/src3390113751/src/src/pages/agreement.vue?macro=true";
import { default as about_45passCl5_45c0uQw8HRSuB9ROH_45vEYGwfHdcx1Lo9NBQkxHdOYMeta } from "/codebuild/output/src3390113751/src/src/pages/about-pass.vue?macro=true";
import { default as indexPIPuKTD1Nr5IBJJe9C2FzMyCHbddc3lzDMn3cru_454yMMeta } from "/codebuild/output/src3390113751/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93NziH5tvJIqklxOkqdBYphMCtjEXzdqNwNu7K9sKd_45yYMeta } from "/codebuild/output/src3390113751/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance_TJn6Kv4fKhUGzWHK84I3QWoZ2TZr3uZW_45htb05KbUoMeta } from "/codebuild/output/src3390113751/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_932BUUn69M4Z51Wq3Ws5nZzHhujnPtXwQ1OZtsncI4E40Meta } from "/codebuild/output/src3390113751/src/src/pages/notice/[id].vue?macro=true";
import { default as indexzN8_45LggLX7eg_F61yGBYMZusIMo5XGdlQ6xctNCofBEMeta } from "/codebuild/output/src3390113751/src/src/pages/coupon/index.vue?macro=true";
import { default as index1iyH5LVi1RsTpfFVi54yEM8A4IUhWJ2_45Uj1E_OeLxOUMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/index.vue?macro=true";
import { default as index5Mck_ijjw7z_45zYtFUfKg_45Ex0cFIG_84XesagDSJKlscMeta } from "/codebuild/output/src3390113751/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93Og4axEju7xLnj3r1zn7arokL3eD5BBPnz0YKbE86oVwMeta } from "/codebuild/output/src3390113751/src/src/pages/parking/[id].vue?macro=true";
import { default as indexXRoi2JPW8zVpuaPyYbeun1_45m0qTx8uLVy8By9IQVu0sMeta } from "/codebuild/output/src3390113751/src/src/pages/history/index.vue?macro=true";
import { default as indexX8imCtG1B8gUNcwU4aYtLRyFT7ZIXc4M_Adb_45VQlp7UMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/index.vue?macro=true";
import { default as indexdNAy8DcLfkP04B75KK6yv2h9AEydWPIEK8i0HyTfPkEMeta } from "/codebuild/output/src3390113751/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexl1dri4Lfa_45hvc1yMmAW9NZVDw_45lpprhR4VBXAVpWRbUMeta } from "/codebuild/output/src3390113751/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviDjAG6T7rR_45zb2Ys2Jofve6W1wdtU_fM4fHi2w6gDJY8Meta } from "/codebuild/output/src3390113751/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editI0yzB3ijz6qr_ikekVV3AQ3JaoPFbQMlWwNojnjZ9UoMeta } from "/codebuild/output/src3390113751/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementSAkoU_0guOIWxv5z56XgNktGAH9z9znkwYFPpJakjp8Meta } from "/codebuild/output/src3390113751/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexcmI3dpRODn0blmQmK3YwPUnh9au0m5J0j95yMiW_45eycMeta } from "/codebuild/output/src3390113751/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dJ0TyMO3B6vWZmijGcRki9C8gXegHdjvZTjsm5Lb8kQkMeta } from "/codebuild/output/src3390113751/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm_a4__45xnUzsCgR2GFqzF_450pPKjwsfpZSzrWwol9rm86oMeta } from "/codebuild/output/src3390113751/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexZdeMOu_45uCE3zhwhUgyBo8WOx_45G4vI5CFvybLuPvL0vIMeta } from "/codebuild/output/src3390113751/src/src/pages/card/create/index.vue?macro=true";
import { default as indexdh1a0VypEiHng_3Y_45YZvtcwZVaQ3sd5ScXBByJzKSugMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmZxupW1cRLIHXniHxizMj5bia_453CrLlAqohARDREk_7AMeta } from "/codebuild/output/src3390113751/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmfCHz_D7D7gttgisYG8L2K7Ypf3GXTlU2QAAE6IbxavEMeta } from "/codebuild/output/src3390113751/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeL9qjWmksCoC_HxzQ7Z_45h1MykU_VFwXSR6epn3Ry2vggMeta } from "/codebuild/output/src3390113751/src/src/pages/membership/complete.vue?macro=true";
import { default as registerdYvF_r2VjXb7FZtBJdc3OyweNhRoCwiUJSezejvaXAAMeta } from "/codebuild/output/src3390113751/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_938hDWr0Xo8bhHnfMRlDNnLaFaRzE6EVDYpyPPXP_Q8kgMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmLsetN_qOGxlUcSV94DtFpRiMG1vm9JJEAeGQU_slAq4Meta } from "/codebuild/output/src3390113751/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_935vguj4NF5DNu3DuU35EEOKzb25mHVSGjhj3mDdAZBu0Meta } from "/codebuild/output/src3390113751/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexhpXtmABXc8po5k9UPLCSFKQeXPNvnwsAtF6JGvPZpOIMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeCEk2gfs_45ahyMcXoUmfBtRNaKLOCRXa0iKo6WXkz_45AzYMeta } from "/codebuild/output/src3390113751/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeeIzlTneuJmfM4RSEjheZs4lc_45Wjj2GT0E7qO2RVKvFQMeta } from "/codebuild/output/src3390113751/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete303wNTQm87DrPIRZjXxFeFjE85CGgep0kAdIf85d31kMeta } from "/codebuild/output/src3390113751/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerWs07dMJSxOBNBovJI_45ucxcn6FgN_IHME_BY6pTjo5wMMeta } from "/codebuild/output/src3390113751/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeSKPikygw31BcM5cij5_45LKpG15Wn10FzowDTTHfB_45LpUMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexEIDv_32_rc0SUWrccgsOU5zslys1dIv1FQkC3chXevYMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmRdDgY6KI4Uono0IMJjwuoRw0cG_45qyUJoNPGvy_jRggUMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeyhJ70Y_45cP_45WI6yhcFsQ7lCuvP5jgF6rxMLXq3igppScMeta } from "/codebuild/output/src3390113751/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexEkj3kEbLxvVI6HGVqDfDIPo7C6vh41CAZuoOEsFXbQ4Meta } from "/codebuild/output/src3390113751/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93KxRjiGpzjHdQxkl0bPRDIXVGt1x7UEm3rCtDKlVVH1MMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeoJxOJkjDFYisqu_Ul4qsnwUIoArjf__459ywxt_cG8lYcMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasZuSOZw2ivUY3raOPj9uLpRmo_45sjWwM2OZjEpf75gGVwMeta } from "/codebuild/output/src3390113751/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplePt4gkVJJviEHTAtAmULgRbyFYhykZuHEStwHg28uqR0Meta } from "/codebuild/output/src3390113751/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email_45ANRL5Kxf_q9wnl85SUp459HL7o0ro2E7O6YHPdbX_oMeta } from "/codebuild/output/src3390113751/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm7QpQCd2lUtx9OvUhHUa9Bamy6DklvdFLIzYY4ZhE6KIMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentYLhPlcVd_45erhux_Q9tgGTTpIaQ4wKkHgX_45GJ5XPJEroMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmxtn2ADdE_f2fDvtYsJSdowWTpuhzB57qTwq9_D3ihf8Meta } from "/codebuild/output/src3390113751/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatekxaLr2M4o1gMCa2iNbj5RSoMqbKsO63fDinJkFgT1CAMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete41qXGh_45TVxw14gJabc5HmgLoTzq8KqvGNmD8JHAYma0Meta } from "/codebuild/output/src3390113751/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code4aUrTfSmuFWYcl73DAEN7VrdHDlrIMWQ7DYqxehuhtMMeta } from "/codebuild/output/src3390113751/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordM9PvlCgydbSG1PAEHltpJgzArS6gaoBLxQdibWrXAkUMeta } from "/codebuild/output/src3390113751/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasQWR9sFWwBQJ_45fMIqWhv9wMHuCwzhAqMnOQxkyZcOv7wMeta } from "/codebuild/output/src3390113751/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerQ7xU0Ros8aGgiAQUc1gkevtIggK6De8g35Yjj5eqa5cMeta } from "/codebuild/output/src3390113751/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codewiYVVr3GXR1MKjexGh10CFxVMgBjpwUkMZ7cKJlTAdQMeta } from "/codebuild/output/src3390113751/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexzCECzEDQ7d6wz3inoV2L93h_4s_45WK7R6mCwbckmCLAkMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexG4AX_45_u__45_45VKxq53hLnwEm80osKp3E_WpFJA2V78pOEMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index_45cEZ1UB_45kQBFJerXPDwVfPEAISeAPK2jgAkpkAFpGloMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexboDnCn4f1I1tQzAneG_LQN3E1RdtX7mJ_vcx9WYexNsMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatepWha1AcuOFjaMMlW110Zl_fyHM5xqLNlUI2k5mn_YJsMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete3SfjTc9QcgWMaoTRSzhW86UMl_45L2Q8xCRZIhUR3P2VkMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmO_mZaebsfzg_45IzI0Zk63ox9k__7s0_eyzX3XOM0kKKoMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indextrBqdSSDdblkN_451_yjkcEyCJg71WmZfZma6tMJh_45Db4Meta } from "/codebuild/output/src3390113751/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeGIlRCWKNfq9ZAvTiPKfZt_c9hZsMPAvEdSaEuMgPmFMMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateAFCBwuc0rcBF3aSCR9_0sejdMW6skp_458nNE4VqAQ_452QMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index4DELwCXzVKvPgpmYKlZyM_45snrukgnvGMTON18iFHRsUMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indext8fUZxsaBEZ5mr3RA45vb8lX_45wnI4F9zvW7Ur6nQ5qUMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeJxNZac_UEVLHrThi3_45I2jzsYhBXvdbKFnd0PDE8IAAAMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexnHzTidmltH_4599JEsE_45OA80KGcVrcxICUxKj8DdTCCm8Meta } from "/codebuild/output/src3390113751/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code6zPCJd_45qLTXwoG2PekUBRrcTIyLGZpDZxTlcZgEpE4kMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexKQpyCJ9wqya9SyT8GrevwK0IoHVsqq_VDwXPEk2AJcMMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexHQrNf56gJlNR8XsYx_457RESeKdPJ8PjOt6ZDk3lM2nJwMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexFZ2b_lb_4522FLTWyANbNHeNmnnas6UERGRI6VnhUdzSEMeta } from "/codebuild/output/src3390113751/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update5JEeDF5eRfPU2TV4oaJzRoCI0c2JoIIsBofnqC8o2rQMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmgl2DOGV03i1R20ymaLh_455FNSB3zjowmnVWw8Wp0F42sMeta } from "/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuEL9xllHKdjjelJRabUhqdB9c8HVwG_45hTSmC_cLXKJFcMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexLdzqi7j7rODMRr4sbSA9u6AO__6_45RohVSE6WAGmgrPkMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3390113751/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexzN8_45LggLX7eg_F61yGBYMZusIMo5XGdlQ6xctNCofBEMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3390113751/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexXRoi2JPW8zVpuaPyYbeun1_45m0qTx8uLVy8By9IQVu0sMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3390113751/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexdNAy8DcLfkP04B75KK6yv2h9AEydWPIEK8i0HyTfPkEMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexl1dri4Lfa_45hvc1yMmAW9NZVDw_45lpprhR4VBXAVpWRbUMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexZdeMOu_45uCE3zhwhUgyBo8WOx_45G4vI5CFvybLuPvL0vIMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmZxupW1cRLIHXniHxizMj5bia_453CrLlAqohARDREk_7AMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmfCHz_D7D7gttgisYG8L2K7Ypf3GXTlU2QAAE6IbxavEMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3390113751/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeL9qjWmksCoC_HxzQ7Z_45h1MykU_VFwXSR6epn3Ry2vggMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerdYvF_r2VjXb7FZtBJdc3OyweNhRoCwiUJSezejvaXAAMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmLsetN_qOGxlUcSV94DtFpRiMG1vm9JJEAeGQU_slAq4Meta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeCEk2gfs_45ahyMcXoUmfBtRNaKLOCRXa0iKo6WXkz_45AzYMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeeIzlTneuJmfM4RSEjheZs4lc_45Wjj2GT0E7qO2RVKvFQMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete303wNTQm87DrPIRZjXxFeFjE85CGgep0kAdIf85d31kMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerWs07dMJSxOBNBovJI_45ucxcn6FgN_IHME_BY6pTjo5wMMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmRdDgY6KI4Uono0IMJjwuoRw0cG_45qyUJoNPGvy_jRggUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeyhJ70Y_45cP_45WI6yhcFsQ7lCuvP5jgF6rxMLXq3igppScMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexEkj3kEbLxvVI6HGVqDfDIPo7C6vh41CAZuoOEsFXbQ4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeoJxOJkjDFYisqu_Ul4qsnwUIoArjf__459ywxt_cG8lYcMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplePt4gkVJJviEHTAtAmULgRbyFYhykZuHEStwHg28uqR0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email_45ANRL5Kxf_q9wnl85SUp459HL7o0ro2E7O6YHPdbX_oMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm7QpQCd2lUtx9OvUhHUa9Bamy6DklvdFLIzYY4ZhE6KIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentYLhPlcVd_45erhux_Q9tgGTTpIaQ4wKkHgX_45GJ5XPJEroMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmxtn2ADdE_f2fDvtYsJSdowWTpuhzB57qTwq9_D3ihf8Meta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete41qXGh_45TVxw14gJabc5HmgLoTzq8KqvGNmD8JHAYma0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code4aUrTfSmuFWYcl73DAEN7VrdHDlrIMWQ7DYqxehuhtMMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordM9PvlCgydbSG1PAEHltpJgzArS6gaoBLxQdibWrXAkUMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerQ7xU0Ros8aGgiAQUc1gkevtIggK6De8g35Yjj5eqa5cMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codewiYVVr3GXR1MKjexGh10CFxVMgBjpwUkMZ7cKJlTAdQMeta || {},
    component: () => import("/codebuild/output/src3390113751/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3390113751/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]